export const CONTRACTS_PAGE_OPTIONS = [
  { label: 'Current contracts', value: 'all' },
  {
    label: 'Category setup',
    value: 'contract_categories'
  },
  {
    label: 'Archived contracts',
    value: 'archived'
  }
]
